import { c as e, d as r } from "../_rollupPluginBabelHelpers-d2f9cf82.js";
var u = require("slugify"),
  n = function (e) {
    return u(e).replace("+", "-").replace("--", "-").replace("---", "-").toLowerCase();
  },
  t = require("uuid").v4,
  o = new (function () {
    function u() {
      r(this, u);
    }
    return e(u, [{
      key: "slugify",
      value: function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
        return n(e);
      }
    }, {
      key: "uniqueId",
      value: function () {
        return t();
      }
    }, {
      key: "getRandomColor",
      value: function (e) {
        for (var r = 0, u = 0; u < e.length; u++) r = e.charCodeAt(u) + ((r << 5) - r);
        return "hsl(".concat(r % 360, ", 70%, 60%)");
      }
    }]), u;
  }())();
export { o as default };